import React, { useEffect, useRef } from 'react';
import styles from './FJTextPreview.module.less';
import classNames from 'classnames';

const FJTextPreview = props => {
    // eslint-disable-next-line react/prop-types
    const { onMouseEvent, textPreviewId, render } = props;
    const content = useRef();

    useEffect(() => {
        if (render) render();
    }, []);

    const _onMouseDown = e => {
        onMouseEvent && onMouseEvent('mouseDown', { x: e.clientX, y: e.clientY });
    };

    const _onDoubleClick = e => {
        onMouseEvent && onMouseEvent('doubleClick', { x: e.clientX, y: e.clientY });
    };

    const _onMouseMove = e => {
        onMouseEvent && onMouseEvent('mouseMove', { x: e.clientX, y: e.clientY });
    };

    const _onWheel = e => {
        onMouseEvent && onMouseEvent('wheel', { x: e.clientX, y: e.clientY });
    };

    return (
        <div
            id={textPreviewId}
            ref={content}
            className={classNames(styles.box, styles.font, styles.scroller_vertical)}
            onMouseDown={_onMouseDown}
            onDoubleClick={_onDoubleClick}
            onMouseMove={_onMouseMove}
            onWheel={_onWheel}
        ></div>
    );
};

// eslint-disable-next-line react-refresh/only-export-components
export default React.memo(FJTextPreview);
